<template>
  <el-dialog
    :title="titleName"
    :visible.sync="dialogVisible"
    :before-close="handleClose"
    width="30%"
    :modal="true"
    :close-on-click-modal="false"
  >
    <div class="container-dialog">
      <div class="left">
        <el-form :model="formInline" ref="form" :rules="rules">
          <el-form-item label="事项目标名称" prop="xm">
            <el-input
              v-model="formInline.xm"
              placeholder="请输入事项目标名称"
            ></el-input>
          </el-form-item>
          <el-form-item label="社区全称" prop="sq">
            <el-select placeholder="请选择社区全称" v-model="formInline.sq">
              <el-option
                v-for="item in commcommunityList"
                :key="item.code"
                :label="item.pointName"
                :value="item.pointName"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="年龄" prop="nl">
            <el-input
              v-model="formInline.nl"
              placeholder="请输入年龄"
            ></el-input>
          </el-form-item>
          <el-form-item label="身份证号" prop="sfzh">
            <el-input
              v-model="formInline.sfzh"
              placeholder="请输入身份证号"
            ></el-input>
          </el-form-item>
          <el-form-item label="事项目标地址" prop="jzdz">
            <el-input
              v-model="formInline.jzdz"
              placeholder="请输入事项目标地址"
            ></el-input>
          </el-form-item>
          <el-form-item label="联系电话" prop="lxdh">
            <el-input
              v-model="formInline.lxdh"
              placeholder="请输入联系电话"
            ></el-input>
          </el-form-item>
          <el-form-item label="备注" prop="bz">
            <el-input
              v-model="formInline.bz"
              placeholder="请输入备注"
              type="textarea"
              :autosize="{ minRows: 4, maxRows: 8 }"
            ></el-input>
          </el-form-item>
          <el-form-item label="启停标识" prop="commonRunState">
            <el-switch
              active-value="ANY"
              inactive-value="CLOSE"
              v-model="formInline.commonRunState"
            >
            </el-switch>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="addOrUpdateFun">保 存</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { extendclRkEdit } from "@/api/task.js";
import commonTable from "@/components/table/index.vue";
import pageChangeSelect from "@/mixins/page-change-select.js";
export default {
  components: {
    commonTable
  },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    curItem: {
      type: Object,
      default: () => {
        return {};
      }
    },
    titleName: {
      type: String,
      defalut: "新增"
    },
    commcommunityList: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  mixins: [pageChangeSelect],
  data() {
    return {
      formInline: {},
      rules: {
        sq: [
          {
            required: true,
            message: "请选择所属社区",
            trigger: ["blur", "change"]
          }
        ],
        xm: [
          {
            required: true,
            message: "请输入姓名",
            trigger: "blur"
          }
        ]
      }
    };
  },
  watch: {
    curItem(val) {
      this.formInline = val;
    }
  },
  mounted() {
    this.formInline = this.curItem;
  },
  methods: {
    handleClose() {
      // 关闭弹窗，触发父组件修改visible值
      this.$emit("update:dialogVisible", false);
    },
    async addOrUpdateFun() {
      this.$refs["form"].validate(async valid => {
        if (valid) {
          let res = await extendclRkEdit(this.formInline);
          console.log(res, 9999);
          if (res.data.code == 200) {
            this.$message({
              type: "success",
              message: "操作成功"
            });
            this.handleClose();
            this.$emit("refreshList");
          } else {
            this.$message({
              type: "error",
              message: res.data.msg
            });
          }
        }
      });
    }
  },
  computed: {},
  watch: {}
};
</script>

<style scoped lang="less">
/deep/.el-dialog__header {
  border: none;
  height: 64px;
  padding: 24px 16px 16px 24px;
  background: none;

  .el-dialog__title {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 20px;
    color: #494c4f;
  }
}

/deep/.el-dialog__body {
  padding: 24px;
  overflow: hidden;
}
.container-dialog {
  overflow: hidden;
  display: flex;
  .left {
    width: 100%;
    height: 660px;
    overflow: auto;
    margin-right: 24px;
  }
}

/deep/ .specialForm {
  display: flex;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/pages/baseInfo/customEvent/components/addDialog.vue